import type { JSX } from 'react';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

import { EMPTY_OBJECT, EMPTY_STRING } from '@e-socna/empty';
import { isDefined } from '@e-socna/utils';

import type { AccordionType } from './types/accordion.type';

interface Props {
  readonly accordion: AccordionType;
}

export const GenerateTable = ({ accordion }: Readonly<Props>) => (
  <TableContainer component={Paper} elevation={0}>
    <Table aria-label={accordion.title}>
      <TableHead>
        <TableRow>
          {accordion.fields.map(({ key, align, label }) => (
            <TableCell align={align} key={`${accordion.id}-head-${key}`}>
              {label}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {accordion.data.map((row, index) => (
          <TableRow
            key={`${accordion.id}-${
              // eslint-disable-next-line dot-notation, @typescript-eslint/prefer-nullish-coalescing
              (row['code'] as string | undefined) || index.toFixed()
            }`}
            sx={{
              '&:last-child td, &:last-child th': {
                border: 0,
              },
            }}
          >
            {accordion.fields.map((field, index) => {
              const value = field.transform
                ? field.transform(row[field.key], row)
                : isDefined(row[field.key])
                  ? row[field.key]
                  : EMPTY_STRING;

              return (
                <TableCell
                  align={field.align}
                  // eslint-disable-next-line react/jsx-props-no-spreading
                  {...(index === 0
                    ? { component: 'th', scope: 'row' }
                    : EMPTY_OBJECT)}
                  key={`${accordion.id}-${
                    // eslint-disable-next-line dot-notation, @typescript-eslint/prefer-nullish-coalescing
                    (row['code'] as string | undefined) || index.toFixed()
                  }-${field.key}`}
                >
                  {value as JSX.Element | string | number | boolean}
                </TableCell>
              );
            })}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </TableContainer>
);
